import { withInstall } from '@hd-front-end/utils'
import Divider from './src/divider.vue'

import type { SFCWithInstall } from '@hd-front-end/utils'

export const ElDivider: SFCWithInstall<typeof Divider> = withInstall(Divider)
export default ElDivider

export * from './src/divider'
